module.exports = __webpack_public_path__ + "static/media/pricing-j.6cdec40a.jpg";